import { useState } from 'react';
import { Link } from 'react-router-dom';
import SectionWave from '../components/SectionWave';
import YogoModal from '../components/YogoModal';
import SEO from '../components/SEO';
import './PageShared.css';

import imgFest     from '../assets/9CB44144-24CD-461B-9E29-E35FF36D1A90-scaled.jpeg';
import imgCandyBar from '../assets/C62D1782-7C47-43A1-89E6-1F27C7DB5CEE.jpeg';
import imgBalloner from '../assets/CF3BB2DA-37C7-4CBB-93E8-2B4DD33E4205-scaled.jpeg';

const DAGSBILLET_URL =
  'https://little-stars.yogo.dk/frontend/index.html?itemType=class_pass_type&itemId=4408&clientWebsiteReferrerUrl=https%3A%2F%2Flittle-stars.dk%2Fmedlem%2F#/login-with-cart';

const medlemskaber = [
  {
    name: '1 barn',
    price: '75',
    features: ['Adgang til legeområde', '1 barn inkluderet', 'Alle voksne inkluderet'],
    color: '#7DCFCA',
    url: 'https://little-stars.yogo.dk/frontend/index.html?itemType=membership_type&itemId=2002&clientWebsiteReferrerUrl=https%3A%2F%2Flittle-stars.dk%2Fmedlem%2F#/login-with-cart',
  },
  {
    name: '2 børn',
    price: '115',
    features: ['Adgang til legeområde', '2 børn inkluderet', 'Alle voksne inkluderet'],
    color: '#E8799F',
    popular: true,
    url: 'https://little-stars.yogo.dk/frontend/index.html?itemType=membership_type&itemId=2198&paymentOption=3169&clientWebsiteReferrerUrl=https%3A%2F%2Flittle-stars.dk%2Fmedlem%2F#/login-with-cart',
  },
  {
    name: '3 børn',
    price: '135',
    features: ['Adgang til legeområde', '3 børn inkluderet', 'Alle voksne inkluderet'],
    color: '#B8A0D4',
    url: 'https://little-stars.yogo.dk/frontend/index.html?itemType=membership_type&itemId=2476&paymentOption=3513&clientWebsiteReferrerUrl=https%3A%2F%2Flittle-stars.dk%2Fmedlem%2F#/login-with-cart',
  },
  {
    name: '4 børn',
    price: '155',
    features: ['Adgang til legeområde', '4 børn inkluderet', 'Alle voksne inkluderet'],
    color: '#F9B98A',
    url: 'https://little-stars.yogo.dk/frontend/index.html?itemType=membership_type&itemId=4852&paymentOption=3513&clientWebsiteReferrerUrl=https%3A%2F%2Flittle-stars.dk%2Fmedlem%2F#/login-with-cart',
  },
];

const udstyr = [
  { name: 'Kaffemaskine', icon: '☕' },
  { name: 'Softice maskine', icon: '🍦' },
  { name: 'Slushice maskine', icon: '🧃' },
  { name: 'Candybar', icon: '🍬' },
  { name: 'Popcornmaskine', icon: '🍿' },
  { name: 'TV til foredrag (200 kr)', icon: '📺' },
];

export default function Priser() {
  const [modalUrl, setModalUrl] = useState(null);

  return (
    <main className="page">
      <SEO
        title="Priser"
        path="/priser"
        description="Se priser på dagsbillet (99 kr) og medlemskaber (75–155 kr/md) hos Little-Stars i Randers NV. Køb billet online og få kode til døren — ingen ventetid."
      />
      {modalUrl && <YogoModal url={modalUrl} onClose={() => setModalUrl(null)} />}

      {/* ── HERO ── */}
      <div className="page-hero">
        <div className="page-hero-bg" style={{ '--c1': '#E8799F', '--c2': '#F9B98A' }} />
        <div className="page-hero-content">
          <div className="page-label">Priser</div>
          <h1>Enkel adgang for <span className="gradient-text">hele familien</span></h1>
          <p>Køb billet online og få en kode til vores dør - ingen ventetid.</p>
        </div>
      </div>

      <SectionWave color="#f8f9fd" />

      {/* ── ADGANG: DAGSBILLET + MEDLEMSKABER ── */}
      <section className="content-section bg-soft">
        <div className="container">

          <div className="section-label">Adgang</div>
          <h2 className="section-title">Vælg det der passer <span className="gradient-text">dig bedst</span></h2>
          <p className="price-ingress">
            Medlemskabet følger barnet - far, mor eller bedsteforældre kan alle komme med.
            Løbende måned + én måneds opsigelse.
          </p>

          {/* Kort-grid: dagsbillet + 4 medlemskaber side om side */}
          <div className="access-grid">

            {/* Dagsbillet */}
            <div className="access-card access-day">
              <div className="ac-header">
                <span className="ac-icon">🎟️</span>
                <span className="ac-tag">Enkelt besøg</span>
              </div>
              <div className="ac-name">Dagsbillet</div>
              <div className="ac-price">99<span>,-</span></div>
              <ul className="ac-features">
                <li><span>✓</span>1 barn</li>
                <li><span>✓</span>Alle voksne</li>
                <li><span>✓</span>Legeområde</li>
                <li><span>✓</span>0–4 mdr. gratis</li>
              </ul>
              <p className="ac-note">Gælder den dag den købes.</p>
              <button onClick={() => setModalUrl(DAGSBILLET_URL)} className="btn btn-primary ac-btn">Køb</button>
            </div>

            {/* Medlemskaber */}
            {medlemskaber.map(m => (
              <div
                className={`access-card${m.popular ? ' access-popular' : ''}`}
                key={m.name}
                style={{ '--card-color': m.color }}
              >
                {m.popular && <div className="popular-badge">Mest valgte</div>}
                <div className="ac-header">
                  <span className="ac-icon">⭐</span>
                  <span className="ac-tag">Medlemskab</span>
                </div>
                <div className="ac-name">{m.name}</div>
                <div className="ac-price">{m.price}<span> kr/md</span></div>
                <ul className="ac-features">
                  {m.features.map(f => <li key={f}><span>✓</span>{f}</li>)}
                </ul>
                <p className="ac-note">Løbende måned + 1 måneds opsigelse.</p>
                <button onClick={() => setModalUrl(m.url)} className="btn btn-primary ac-btn">Vælg</button>
              </div>
            ))}

          </div>

          <p style={{ marginTop: '1rem', fontSize: '0.82rem', color: '#9494b0' }}>
            Ved køb af medlemskab accepterer du vores{' '}
            <Link to="/handelsbetingelser" style={{ color: '#E8799F', textDecoration: 'underline' }}>handelsbetingelser</Link>.
          </p>

          {/* Info-stribe i bunden */}
          <div className="price-info-strip">
            <div className="info-strip-item">
              <span>🌟</span>
              <div>
                <strong>20% rabat</strong> med Randers Regnskov årskort - gælder på dagsbillet og medlemskab.
              </div>
            </div>
            <div className="info-strip-item">
              <span>💡</span>
              <div>
                <strong>Byttet dagsbillet til medlemskab?</strong> Få prisen refunderet - send os en mail.
              </div>
            </div>
            <div className="info-strip-item">
              <span>🔔</span>
              <div>
                Selvom vi har udlejninger, kan du altid benytte <strong>afdeling 2</strong> i weekenderne. Brug døren til venstre.
              </div>
            </div>
          </div>

        </div>
      </section>

      <SectionWave color="#ffffff" flip />

      {/* ── UDLEJNING ── */}
      <section className="content-section bg-white">
        <div className="container">
          <div className="section-label">Lokaleudlejning</div>
          <h2 className="section-title">Lej til din næste <span className="gradient-text">fest eller event</span></h2>

          <div className="rental-layout">

            <div className="rental-info">
              <p className="rental-desc">
                Hos os er der plads til både vilde hop, leg og latter - og til de store øjeblikke der skal fejres.
                Du får <strong>hele afdeling 1</strong> for jer selv til barnedåb, konfirmation, fødselsdag eller andet.
              </p>
              <p className="deposit-note">
                Du er altid velkommen til at skrive til os, selv hvis datoen allerede er booket, så kontakter vi dig ved afbud.
              </p>

              {/* Priser */}
              <div className="rental-prices">
                <div className="rental-price-row">
                  <span>📅 Lørdag</span>
                  <strong>2.500 kr</strong>
                </div>
                <div className="rental-price-row">
                  <span>📅 Søndag</span>
                  <strong>2.500 kr</strong>
                </div>
                <div className="rental-price-row highlight">
                  <span>📅 Hel weekend</span>
                  <strong>4.000 kr</strong>
                </div>
                <div className="rental-price-row deposit">
                  <span>🔒 Depositum</span>
                  <strong>1.000 kr</strong>
                </div>
                <div className="rental-price-row">
                  <span>🧹 Rengøring (obligatorisk)</span>
                  <strong>500 kr</strong>
                </div>
              </div>

              <p className="deposit-note">
                Depositum betales ved reservation og tilbagebetales efter festen.
                Tilbagebetales <em>ikke</em> ved aflysning.
              </p>

              <div className="rental-contact">
                <a href="mailto:info@little-stars.dk" className="btn btn-primary">
                  📧 info@little-stars.dk
                </a>
                <a href="tel:31525943" className="btn btn-outline">
                  📞 31 52 59 43
                </a>
              </div>
            </div>

            <div className="rental-details">
              {/* Hvad er inkluderet */}
              <div className="included-card">
                <h3>Hvad er inkluderet?</h3>
                <ul>
                  <li>✓ Op til <strong>100 personer</strong></li>
                  <li>✓ Borde, stole og service</li>
                  <li>✓ The-køkken med opvaskemaskiner og køleskab</li>
                  <li>✓ Anretterkøkken med to ovne og to store køleskabe</li>
                  <li>✓ Adgang til legeområde for børnene</li>
                </ul>
              </div>

              {/* Tilvalg */}
              <div className="extras-card">
                <h3>Tilvalg til leje</h3>
                <div className="extras-grid">
                  {udstyr.map(u => (
                    <div className="extra-item" key={u.name}>
                      <span>{u.icon}</span>
                      <span>{u.name}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

          </div>

          {/* Billeder */}
          <div className="rental-imgs-row">
            <img src={imgFest}     alt="Festlokale" />
            <img src={imgCandyBar} alt="Candy bar"  />
            <img src={imgBalloner} alt="Balloner"   />
          </div>

        </div>
      </section>

      <SectionWave color="#f8f9fd" />

    </main>
  );
}
